import React from 'react';
import {AnchoredPopover} from './AnchoredPopover';
import {LineUncoveredContent} from './LineUncoveredContent';
import {levelModifier} from './uncoveredSpend';

// Lo que importaban otros módulos de acá antes de partirlo en tres (tanda «Inversión sin línea», 16/10).
export {popoverPosition, popoverWidth} from './AnchoredPopover';
export {editCampaignsPath, UNCOVERED_CENTER_PATH} from './LineUncoveredContent';
export {breakableName} from './UncoveredCampaignRow';

/**
 * El detalle del chip de la línea «No cuenta N campañas»: el armazón (`AnchoredPopover`: portal, posición,
 * foco y cierre) con el contenido de la línea (`LineUncoveredContent`). El color del nivel va en el panel:
 * lo usa el monto (`__total`).
 *
 * El componente no escribe: las acciones son del chip, que es quien descuenta lo resuelto.
 */
export function UncoveredSpendPopover({id, uncovered, accounts, businessUnitId, anchorRef, onClose, onDismiss, busyKey,
                                          uncontrolledSpendEnabled}) {
    const titleId = `${id}-title`;
    return (
        <AnchoredPopover id={id} anchorRef={anchorRef} onClose={onClose} labelledBy={titleId}
                         className={levelModifier(uncovered.level)} testId="uncovered-spend-popover">
            <LineUncoveredContent titleId={titleId} uncovered={uncovered} accounts={accounts}
                                  businessUnitId={businessUnitId} onClose={onClose} onDismiss={onDismiss}
                                  busyKey={busyKey} uncontrolledSpendEnabled={uncontrolledSpendEnabled}/>
        </AnchoredPopover>
    );
}

export default UncoveredSpendPopover;
